import { Suspense } from "react";
import Box from "@mui/material/Box";
import { Outlet } from "react-router-dom";
import RouteFallback from "../../app/routing/fallback/RouteFallback";
import TopProgressBar from "../../shared/components/common/ui/TopProgressBar";
import { AppNavbar, MainContent, SideMenu } from "./components";
import {
  getAppLayoutBackgroundColor,
  useSidebarDarkMode,
} from "./useAppLayoutAppearance";

export default function AppLayout() {
  const sidebarDark = useSidebarDarkMode();
  const backgroundColor = getAppLayoutBackgroundColor(sidebarDark);

  return (
    <Box
      sx={{
        backgroundColor,
        display: "flex",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <TopProgressBar />
      <AppNavbar />
      <SideMenu />
      <MainContent>
        <Suspense fallback={<RouteFallback />}>
          <Outlet />
        </Suspense>
      </MainContent>
    </Box>
  );
}
